import { HallBookingsInformationWorkspace } from "./HallBookingsInformationWorkspace";

export const BookingInfoTab = () => <HallBookingsInformationWorkspace />;

export default BookingInfoTab;
